if($('footer#footer').length){
    $('.footer-bottom').insertAfter('footer#footer').wrap('<div class="underFooter"></div>')
    $('#signature').append('<span class="signatureFirm"> | <a href="https://www.dostmedia.cz/" target="_blank">Dostmedia</a></span>')
    $('footer#footer').before($('footer#footer .customInstagram'))    
    $('footer#footer .contact-box span.mail').closest('li').appendTo('.superContacts')
    $('footer#footer .contact-box span.tel').closest('li').appendTo('.superContacts')
    $('footer#footer .contact-box span.facebook').closest('li').appendTo('.customSocial')
    $('footer#footer .contact-box span.instagram').closest('li').appendTo('.customSocial')
    $('footer#footer .contact-box span.youtube').closest('li').appendTo('.customSocial')
    $('footer#footer .contact-box span.tiktok').closest('li').appendTo('.customSocial')
    $(".instagram-widget>a").each(function(){
        $(".instagramFeed").append('<div class="igPost"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')
    })
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    })
    $('.footer-links-icons .footer-icons').before('<h4><span>Přijímáme online platby</span></h4>')
    $('.newsletter-header h4 span').text('Chcete novinky z našeho centra  první ruky?');
    $('body').append($('footer#footer .btn-rezervio'))
}